var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.sections),function(section){return _c('card-section',{key:section.id,attrs:{"section":section},on:{"elements-changed":function($event){return _vm.$emit('elements-changed')}}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }